import React from 'react';
import PropTypes from 'prop-types';
import './ErrorMessage.css';

const ErrorMessage = ({
  children,
}) => (
  <span className="error-message">
    <i className="material-icons">cancel</i>
    <span>
      {children}
    </span>
  </span>
);

ErrorMessage.propTypes = {
  children: PropTypes.node,
};

ErrorMessage.defaultProps = {
  children: '',
};

export default ErrorMessage;



// WEBPACK FOOTER //
// ./src/components/ErrorMessage/ErrorMessage.jsx